var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import get from 'lodash.get';
import isEmpty from 'lodash.isempty';
import { useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import useDesign from '../../../hooks/useDesign';
import { GenericComponent } from '../../atoms/GenericComponent';
import { Button } from '../../molecules/Button';
import { FormAlert } from './FormAlert';
import { FormField } from './FormField';
export var FormFieldArray = function (_a) {
    var design = _a.design, disabled = _a.disabled, defaultAddValues = _a.defaultAddValues, onFieldArrayChanged = _a.onFieldArrayChanged, props = __rest(_a, ["design", "disabled", "defaultAddValues", "onFieldArrayChanged"]);
    var _b = useDesign(design), components = _b.components, config = _b.config, schema = _b.schema;
    var removeButton = components.removeButton, addButton = components.addButton;
    var name = __assign(__assign({}, config), props).name;
    var _c = useFormContext(), control = _c.control, errors = _c.formState.errors, getValues = _c.getValues;
    var _d = useFieldArray({
        control: control,
        name: name,
    }), fields = _d.fields, append = _d.append, remove = _d.remove;
    var error = get(errors, name);
    var hasError = !isEmpty(error);
    var values = getValues(name);
    var handleRemove = function (id) { return function () { return remove(id); }; };
    // Adding implies replicating the already defined structure.
    // For this, we're cloning the first group of fields.
    // Providing default values if any.
    var handleAdd = function () {
        var clone = Object.keys(fields[0]).reduce(function (acc, key) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[key] = (defaultAddValues && defaultAddValues[key]) || '', _a)));
        }, {});
        append(clone);
    };
    useEffect(function () {
        if (onFieldArrayChanged)
            onFieldArrayChanged(fields);
    }, [fields]);
    return (_jsxs(GenericComponent, __assign({ schema: schema, "data-design": design }, { children: [fields.map(function (field, index) { return (_jsxs(GenericComponent, __assign({ schema: schema.row, "data-design": "".concat(design, ".container") }, { children: [Object.keys(field).map(function (key) {
                        var _a;
                        var fieldName = "".concat(name, ".").concat(index, ".").concat(key);
                        var value = (_a = values[index]) === null || _a === void 0 ? void 0 : _a[key];
                        var componentDesign = components[key];
                        return (componentDesign && (_jsx(FormField, __assign({ "data-design": "".concat(design, ".container.").concat(fieldName), design: componentDesign, name: fieldName, value: value }, props), fieldName)));
                    }), _jsx(Button, { "data-design": "".concat(design, ".container.").concat(field.id), design: removeButton, onClick: handleRemove(index), disabled: fields.length === 1 }, "".concat(field.id, ".remove"))] }), field.id)); }), _jsx(Button, { "data-design": "".concat(design, ".container.addButton"), design: addButton, onClick: handleAdd, disabled: disabled }), hasError && _jsx(FormAlert, { design: error.design || error })] })));
};
FormFieldArray.displayName = 'FormFieldArray';
